/* Component Dependencies */
var changePasswordChallengeTemplate = require('templates/changePasswordChallenge.hbs');
var PostalAddressBase = require('libs/postalAddress-base');
var PubSub = require('libs/pub-sub');
var passwordValidation = require('utils/passwordValidation.js');

PubSub.register(PostalAddressBase.extend({
  type: 'changePasswordChallenge',
  template: {
    'changePasswordChallenge': changePasswordChallengeTemplate
  },
  defObj: {
    addressSection: ''
  },
  bindEvents: function($) {
    var _self = this;
    _self.bindPostalAddressBase();
    _self.bindChangeEvent($);
    var passwordValidationOptions = {
      isLabelIcon: _self.$el.find('.new-password-confirmation').data('islabelicon'),
      passwordModuleSelector: '.js-password-info',
      passwordIconSelector: '.js-field-password .t-icon',
      confirmPasswordIconSelector: '.js-field-password-confirmation .t-icon',
      errorClasses: 't-icon-cross',
      successClasses: 't-icon-check',
      validateConfirmPassword: _self.$el.find('.new-password-confirmation').data('validateconfirmpassword'),
      confirmPasswordFieldSelector: '.js-field-password-confirmation'
    };
    passwordValidation.initialize(_self.$el, passwordValidationOptions);

  }
}));
